var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"memory"},[(_vm.layout === 'full' || _vm.layout === 'list')?_c('MemoryList',{attrs:{"memory":_vm.memory,"is-feed":_vm.isFeed}}):_c('MemoryGrid',{attrs:{"memory":_vm.memory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }